'use client';
import { createQuery, SessionStorageCache } from '@s7/query';
import { cyrb53 } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useFooterQuery = createQuery(function(param) {
    var cache = param.cache, url = param.url, code = param.code, device = param.device, lang = param.lang;
    return _extends({}, cache && {
        persist: cyrb53(url + code + device + lang)
    }, {
        query: [
            url,
            {
                searchParams: {
                    code: code,
                    device: device,
                    lang: lang
                }
            }
        ],
        cache: SessionStorageCache
    });
});

export { useFooterQuery };
